import React, { useEffect, useRef } from "react";

const Starfield = () => {
    const canvasRef = useRef();

    useEffect(() => {
        if (typeof window === "undefined") return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let animationFrameId;

        // Ensure canvas dimensions are set correctly before animation starts
        const initializeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            console.log("Canvas initialized: ", canvas.width, canvas.height);
        };

        // Generate stars based on canvas dimensions
        const generateStars = () => {
            return Array(100).fill().map(() => ({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                size: Math.random() * 1.5,
                speed: Math.random() * 0.3 + 0.1,
            }));
        };

        // Create stars after canvas initialization
        initializeCanvas();
        const stars = generateStars();

        const render = () => {
            // Clear the canvas
            ctx.fillStyle = "black";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw and update stars
            stars.forEach((star) => {
                ctx.beginPath();
                ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
                ctx.fillStyle = "#ffffff";
                ctx.fill();

                // Move star downward
                star.y += star.speed;

                // Reset star if it moves off-screen
                if (star.y > canvas.height) {
                    star.y = 0; // Reset to the top
                    star.x = Math.random() * canvas.width; // Randomize x position
                }
            });

            animationFrameId = requestAnimationFrame(render);
        };

        // Update canvas size on window resize
        const handleResize = () => {
            initializeCanvas();
            stars.forEach((star) => {
                star.x = Math.random() * canvas.width;
                star.y = Math.random() * canvas.height;
            });
            console.log("Canvas resized: ", canvas.width, canvas.height);
        };

        // Start animation
        render();

        // Add event listener for resizing
        window.addEventListener("resize", handleResize);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: -1,
            }}
        />
    );
};

export default Starfield;
